module.exports = __webpack_public_path__ + "static/media/portfolio.95526bcc.png";